"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnDetailsActionsMenu = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const RemoteTypeIcon_1 = require("../datagrid/cellFormatters/RemoteTypeIcon");
const ColumnAndFieldDetailsStyles_1 = require("../style/ColumnAndFieldDetailsStyles");
const ColumnActionsMenuHelper_1 = require("./ColumnActionsMenuHelper");
const testId = 'column-dialog-actions';
function ColumnDetailsActionsMenu(props) {
    var _a, _b;
    const { columnId, column, enterDescriptionEdit, enterTaggingEdit, canUpdate } = props;
    const [buttonEl, setButtonEl] = react_1.default.useState(null);
    const { customLabelCategoriesEnabled } = (0, catalog_core_1.useFeatureFlags)();
    const actionsMenu = (0, ColumnActionsMenuHelper_1.useActionsMenu)({
        columnLuid: column.luid,
        columnName: (_a = column.name) !== null && _a !== void 0 ? _a : '',
        columnRemoteType: column.remoteType,
        enterDescriptionEdit: enterDescriptionEdit,
        enterTaggingEdit: enterTaggingEdit,
    });
    if (!columnId) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, title: catalog_messages_1.Messages.Actions(), testId: testId + '-button', getContent: (s) => react_1.default.createElement(ColumnActionsMenuHelper_1.ActionStatusIcon, { hover: s.hover || s.active || false }), buttonRef: setButtonEl, onClick: () => actionsMenu.setIsMenuShowing(!actionsMenu.isMenuShowing), style: ColumnAndFieldDetailsStyles_1.detailsDialogActionsMenuButtonStyle, disabled: !canUpdate, tabIndex: -1 }),
        actionsMenu.isMenuShowing && (react_1.default.createElement(widgets_1.FlyoutListMenuWidget, { anchorEl: buttonEl, menuItemInfos: (0, ColumnActionsMenuHelper_1.ColumnActionItems)({ columnLuid: column.luid, canUpdate, customLabelCategoriesEnabled }), testId: testId + '-menu', toggleEl: buttonEl, menuStyle: ColumnActionsMenuHelper_1.ListMenuStyle, onSelect: (value) => {
                actionsMenu.onSelect(value);
            }, requestCloseAll: () => {
                actionsMenu.setIsMenuShowing(false);
            } })),
        actionsMenu.isCustomDialogShowing && (react_1.default.createElement(data_catalog_shared_1.CustomLabelDialog, { contentItem: {
                contentId: column.luid,
                contentName: (_b = column.name) !== null && _b !== void 0 ? _b : '',
                contentType: 'column',
                contentIcon: react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: column.remoteType }),
                contentIconTitle: data_catalog_shared_1.RemoteTypeMappings[column.remoteType](),
            }, close: actionsMenu.hideCustomDialog, dismiss: actionsMenu.hideCustomDialog }))));
}
exports.ColumnDetailsActionsMenu = ColumnDetailsActionsMenu;
//# sourceMappingURL=ColumnDetailsActionsMenu.js.map